<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Create Contact',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Contact
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Discard" @click="handleDiscard"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierContactForm 
                        class="ma-3" 
                        ref="form" 
                        v-model="form" 
                        v-if="!supplierLoading"
                    />
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading"/>
    </v-container>
</template>

<script>
import PIconBtn from '../../components/common/PIconBtn.vue';
import PAlert from './../../components/common/PAlert.vue';
import SupplierContactForm from './../../components/purchase/SupplierContactForm.vue'
import LoadingOverlay from './../../components/common/LoadingOverlay.vue'
import { mapActions } from 'vuex';
import { v4 as uuid } from 'uuid';

export default {
    name: "SupplierContactCreateView",
    components: {
        PAlert,
        SupplierContactForm,
        PIconBtn,
        LoadingOverlay

    },
    data () {
        return {
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            loading: false,
            supplierLoading: false,
            form: null,
            idempotentKey: null
        }
    },
    methods: {
        ...mapActions({
            findByID: "purchase/supplier/find",
            pushSupplier: "purchase/supplier/push",
            snackbar: "ui/snackbar/show",
            create: "purchase/supplierContact/create"
        }),
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to Save", callback: this.save }

        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.form, idempotentKey: this.idempotentKey}).then(response => {
                this.snackbar({ text: "Supplier Contact Created", color: "success"})
                this.$router.push({ name: "SupplierContactDisplay", params: { id: response.data.id}})
            }).catch(error => {
                let message = error.response? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            })
        },
        handleDiscard() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to Discard", callback: this.discard }
        },
        discard() {
            this.$router.back()
        },
        fetchSupplier() {
            this.supplierLoading = true;
            this.findByID(this.supplierId).then(response => {
                this.pushSupplier(response.data);
                this.form = {}
                this.form.supplier_id = response.data.id;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error" })
            }).finally(() => {
                this.supplierLoading = false;
            })
        }
    },
    mounted() {
        if(this.$route.query.supplier) {
            this.supplierId = this.$route.query.supplier;
            this.fetchSupplier();
        }
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>